import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface PropertyTypeSelectProps {
  propertyType: string;
  setPropertyType: (value: string) => void;
}

export function PropertyTypeSelect({
  propertyType,
  setPropertyType,
}: PropertyTypeSelectProps) {
  return (
    <div className="space-y-4">
      <Label>Tipo de Anúncio</Label>
      <RadioGroup
        value={propertyType}
        onValueChange={setPropertyType}
        className="flex flex-col space-y-1"
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="sale" id="sale" />
          <Label htmlFor="sale">Venda</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="rent" id="rent" />
          <Label htmlFor="rent">Aluguel Mensal</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="seasonal" id="seasonal" />
          <Label htmlFor="seasonal">Temporada</Label>
        </div>
      </RadioGroup>
    </div>
  );
}